/**
 * Devuelve un Set con el id de una cuenta y el de todas sus cuentas
 * descendientes (hijas, nietas, etc.) dentro de la lista de cuentas.
 *
 * Se usa para excluir opciones inválidas del selector "Cuenta Padre":
 * una cuenta no puede tener como padre a sí misma ni a un descendiente,
 * ya que eso crearía un ciclo en la jerarquía contable.
 *
 * @param {Array} accounts - Lista de cuentas contables ({ id, parentAccount }).
 * @param {*}     accountId - Id de la cuenta que se está editando.
 * @returns {Set} Ids de la cuenta y sus descendientes.
 */
export const getSelfAndDescendantAccountIds = (accounts = [], accountId) => {
  const excluded = new Set();
  if (accountId === null || accountId === undefined) return excluded;

  excluded.add(accountId);
  let changed = true;
  while (changed) {
    changed = false;
    for (const account of accounts) {
      if (!excluded.has(account.id) && excluded.has(account.parentAccount)) {
        excluded.add(account.id);
        changed = true;
      }
    }
  }
  return excluded;
};
